import { ref, watch } from "vue";
export function useToggleableComponent(props, emit) {
  const isActive = ref(props.modelValue);
  watch(() => props.modelValue, (newValue) => {
    isActive.value = newValue;
  });
  watch(isActive, (newValue) => {
    if (!!newValue !== props.modelValue) {
      emit("update:modelValue", newValue);
    }
  });
  return {
    isActive
  };
}
